interface GenerateDefaultPromptParams {
  lensName: string;
  attributeNames?: string;
  coachingHubPrompt?: string;
}

export const generateDefaultCoachingPrompt = ({ lensName, attributeNames, coachingHubPrompt }: GenerateDefaultPromptParams): string => {
  const basePrompt = coachingHubPrompt || `Generate coaching insights for the ${lensName} lens.`;

  if (attributeNames) {
    const attributePrompt = `Focus on the following attributes: ${attributeNames}`;
    return `${basePrompt}\n\n${attributePrompt}`;
  }

  return basePrompt;
};

interface ExtractReportTitleParams {
  prompt: string;
  fallbackTitle: string;
}

export const extractReportTitle = ({ prompt, fallbackTitle }: ExtractReportTitleParams): string => {
  const reportTitleMatch = prompt.match(/- Report Title:\s*(.+)/i);
  if (reportTitleMatch && reportTitleMatch[1]) {
    return reportTitleMatch[1].trim();
  }
  return fallbackTitle;
};
